import { render, staticRenderFns } from "./AddContributionPage.vue?vue&type=template&id=63ef4f4c&scoped=true&"
import script from "./AddContributionPage.vue?vue&type=script&lang=js&"
export * from "./AddContributionPage.vue?vue&type=script&lang=js&"
import style0 from "./AddContributionPage.vue?vue&type=style&index=0&id=63ef4f4c&prod&lang=scss&scoped=true&"
import style1 from "./AddContributionPage.vue?vue&type=style&index=1&id=63ef4f4c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ef4f4c",
  null
  
)

export default component.exports